'use strict';

const BaggageModel = Odigeo.Model.extend({
    dataUrl: 'getallbaggage',
    defaults: {},
    url: function() {
        return Odigeo.Settings.getProperty('serviceUrlFormatter')(this.dataUrl);
    },
    getDataRequestSettings: function() {
        return {
            success: Odigeo._.bind(this.requestSuccessHandler, this),
            error: Odigeo._.bind(this.requestErrorHandler, this),
        };
    },
    requestSuccessHandler: function(data) {
        if (!Odigeo._.isEmpty(data)) {
            this.trigger('responseIsOK', data);
        }
    },
    requestErrorHandler: function() {
        this.trigger('responseIsKO');
    },
});
let instance;
module.exports.BaggagesModelClass = BaggageModel;
module.exports.getInstance = function() {
    if (Odigeo._.isUndefined(instance)) {
        instance = new BaggageModel();
    }

    return instance;
};
